import { configureStore } from '@reduxjs/toolkit';
import appointmentFilterSlice from './Reducers/appointmentFilterSlice';
import dynamicStoreSlice from './Reducers/dynamicStoreSlice';

const store = configureStore({
  reducer: {
    appointment: appointmentFilterSlice,
    dynamicStore: dynamicStoreSlice,
    // Add other slice reducers here if needed
  },
});

export default store;
